import { css } from 'lit';
import { CSSResultArray, LitElement, css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('app-bubble')
export default class AppBubble extends LitElement {
	@property({ type: Number }) public count = 0;

	public static override get styles(): CSSResultArray {
		return [
			css`
				div.bubble {
					border-radius: 50%;
					width: 2.5rem;
					height: 2.5rem;
					color: white;
					position: absolute;
					background-color: rgb(199, 72, 47);
					font-weight: 400;
					display: flex;
					align-items: center;
					justify-content: center;
					top: -0.75rem;
					left: calc(100% - 1.25rem);
				}
			`,
		];
	}

	override render() {
		if (this.count === 0) {
			return nothing;
		}
		return html`<div class="bubble">${this.count}</div>`;
	}
}
